<!-- <div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Candidate Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Candidate Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="single-profile-area pt-100">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-lg-5">
                <div class="single-profile-item">
                    <img src="assets/img/single-profile/2.jpg" alt="Profile">

                    <div class="single-profile-left">
                        <div class="single-profile-contact">
                            <h3>Contact Info</h3>

                            <ul>
                                <li><i class="icofont-ui-call"></i> <a href="tel:+07554332322">Call : +07 554 332 322</a></li>
                                <li><i class="icofont-email"></i> <a href="mailto:hello&#64;peof.com">hello&#64;peof.com</a></li>
                                <li><i class="icofont-location-pin"></i> 4th Floor, 408 No Chamber</li>
                            </ul>
                        </div>

                        <div class="single-profile-social">
                            <h3>Social Links</h3>

                            <ul>
                                <li><i class="icofont-facebook"></i> <a href="#" target="_blank">https://www.facebook.com</a></li>
                                <li><i class="icofont-instagram"></i> <a href="#" target="_blank">https://www.instagram.com</a></li>
                                <li><i class="icofont-linkedin"></i> <a href="#" target="_blank">https://www.linkedin.com</a></li>
                                <li><i class="icofont-twitter"></i> <a href="#" target="_blank">https://www.twitter.com</a></li>
                            </ul>
                        </div>

                        <div class="single-profile-skills">
                            <h3>My Skills</h3>

                            <div class="skill">
                                <p>Frontend Design</p>
                                <div class="skill-bar skill1 wow slideInLeft animated">
                                    <span class="skill-count1">70%</span>
                                </div>
                            </div>

                            <div class="skill">
                                <p>Software Development</p>
                                <div class="skill-bar skill1 skill2 wow slideInLeft animated">
                                    <span class="skill-count1">90%</span>
                                </div>
                            </div>

                            <div class="skill">
                                <p>UIUX Design</p>
                                <div class="skill-bar skill1 skill3 wow slideInLeft animated">
                                    <span class="skill-count1">75%</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-7">
                <div class="single-profile-item">
                    <div class="single-profile-right">
                        <div class="single-profile-name">
                            <h2>Jac Jacson</h2>
                            <span>Web Consultant</span>
                            <p>Bachelor of Business Administation university of Gable</p>
                            <a routerLink="/">View CV <i class="icofont-eye-alt"></i></a>
                            <a routerLink="/">Download CV <i class="icofont-download"></i></a>
                        </div>

                        <div class="single-profile-textarea">
                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Description</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p class="single-profile-p">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra maecenas accumsan lacus vel facilisis.Lorem ipsum dolor sit amet, consectetur adipiscing.</p>
                                <p>Risus commodo viverra maecenas accumsan lacus vel facilisis.Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt.</p>
                            </div>

                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Education</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <ul>
                                    <li>PHD degree in Criminal Law at University of Gable Internatinal (2006)</li>
                                    <li>Master of Family Law  at University of Gable International  (2002)</li>
                                    <li>MBBS LLB (Hon’s) in  at University of Gable International (2002)</li>
                                    <li>Higher Secondary Certificate at Gable International collage  (1991)</li>
                                </ul>
                            </div>

                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Research</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Quis ipsum suspendisse ultrices gravida. Risus commodo viverra</p>
                            </div>

                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Work Experiences</h3>
                            </div>
                            
                            <div class="single-profile-paragraph">
                                <ul>
                                    <li>Hand On experience with Wordpress</li>
                                    <li> Better knowledge of front-end technologies, including HTML5, CSS3, JavaScript, jQuery</li>
                                    <li>Belief – believing in yourself and those around you</li>
                                    <li>Experience designing and developing responsive design websites</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div> -->




<div class="page-title-area">
    <div class="d-table">
        <div class="d-table-cell">
            <div class="container">
                <div class="page-title-text">
                    <h2>Candidate Details</h2>
                    <ul>
                        <li><a routerLink="/">Home</a></li>
                        <li><i class="icofont-simple-right"></i></li>
                        <li>Candidate Details</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container back-link">
    <a routerLink="/employer/assigned-candidates-list" class="cursor_pointer h5"><i class="fa fa-angle-double-left me-2"></i>Back</a>
</div>


<div class="single-profile-area pt-100">
    <div class="container-fluid p-5">
        <div class="row align-items-center">
            <div class="col-lg-3">
                <div class="single-profile-item">
                    <!-- <ng-container
                    *ngIf="
                        candidateInfo?.candidateImageDetails?.imageUrl &&
                            candidateInfo?.candidateImageDetails?.imageUrl.trim() !==
                                '';
                        else avatarImage
                    "
                >
                    <img
                        [src]="
                            candidateInfo?.candidateImageDetails?.imageUrl
                        "
                        class="profile_images"
                        alt="Profile"
                    />
                </ng-container>
                <ng-template #avatarImage>
                    <img
                        src="../../../assets/dummy/dummy-candidate.png"
                        class="profile_images"
                        alt="Profile"
                    />
                </ng-template> -->
                <div class="single-profile-left">
                    <div class="single-profile-contact">
                        <h3>Contact Info</h3>

                        <ul class="unordered-list">
                            <li>
                                <i class="icofont-ui-call"></i>
                                <a href="tel:+07554332322"
                                    >Call :
                                    {{
                                        candidateInfo.phoneNumber
                                            ? candidateInfo.phoneNumber
                                            : "***"
                                    }}</a
                                >
                            </li>
                            <li>
                                <i class="icofont-email"></i>
                                <a href="mailto:hello&#64;peof.com">{{
                                    candidateInfo.email
                                        ? candidateInfo.email
                                        : "***"
                                }}</a>
                            </li>
                            <li>
                                <i class="icofont-location-pin"></i
                                >{{
                                    candidateInfo.address
                                        ? candidateInfo.address
                                        : "***"
                                }}
                            </li>
                        </ul>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Skills</h3>
                            @for (data of candidateInfo?.skills; track
                            $index) {
                            <p>{{ data?.skill }}</p>

                            } @empty {
                            <p>No Skills</p>
                            }
                        </div>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Resume</h3>
                            <div *ngIf="candidateInfo.candidateResumeDetails?.imageUrl; else noResume">
                                <ng-container *ngIf="candidateInfo.candidateResumeDetails">
                                    <a class="certificate" [href]="candidateInfo.candidateResumeDetails.imageUrl" target="_blank" rel="noopener noreferrer" download="{{ candidateInfo.candidateResumeDetails.imageName }}">
                                     <p  >{{ candidateInfo.candidateResumeDetails.imageName }}</p> 
                                    </a>
                                  </ng-container>
                            </div>
                        
                            <!-- No Resume message -->
                            <ng-template #noResume>
                                <p>No Resume Available</p>
                            </ng-template>
                        </div>
                    </div>

                    <div class="single-profile-skills">
                        <div>
                            <h3>Cover Letter</h3>
                            <div *ngIf="candidateInfo.candidateCoverLetterDetails?.imageUrl; else noCoverLetter">
                                <ng-container *ngIf="candidateInfo.candidateCoverLetterDetails">
                                    <a class="certificate" [href]="candidateInfo.candidateCoverLetterDetails.imageUrl" target="_blank" rel="noopener noreferrer" download="{{ candidateInfo.candidateResumeDetails.imageName }}">
                                     <p  >{{ candidateInfo.candidateCoverLetterDetails.imageName }}</p> 
                                    </a>
                                  </ng-container>
                            </div>
                            <!-- No Resume message -->
                            <ng-template #noCoverLetter>
                                <p>No Cover Letter</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
                </div>
            </div>
            
            <div class="col-lg-8">
                <div class="scroll-container">
                <div class="single-profile-item">
                    <div class="single-profile-right">
                        <div class="single-profile-name">
                            <ng-container *ngIf="candidateInfo?.firstName || candidateInfo?.middleName || candidateInfo?.lastName ; else defaultName">
                                <h2>{{ candidateInfo?.firstName }} {{ candidateInfo?.middleName }} {{ candidateInfo?.lastName }}</h2>
                            </ng-container>
                            <ng-template #defaultName>
                                <h2>{{candidateInfo?.publicName}}</h2>
                            </ng-template>
                            <!-- <h2>{{candidateInfo?.publicName}}</h2> -->
                            <span>{{candidateInfo?.category ? candidateInfo?.category : "*****" }}</span>
                            <!-- <a routerLink="/">View CV <i class="icofont-eye-alt"></i></a>
                            <a routerLink="/">Download CV <i class="icofont-download"></i></a> -->
                        </div>

                        <div class="single-profile-textarea">
                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Job Title</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p class="single-profile-p">{{candidateInfo?.jobTitle ? candidateInfo?.jobTitle : "No Job Title Exist"}}</p>
                            </div>
                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Personal Summary</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <p class="single-profile-p">{{candidateInfo?.description ? candidateInfo?.description : "No Description"}}</p>
                            </div>

                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Education</h3>
                            </div>

                            <div class="single-profile-paragraph">
                                <ul class="unordered-list">
                                    <!-- Loop through the qualifications array -->
                                    <ng-container *ngIf="candidateInfo?.qualifications?.length; else noEducation">
                                        <li *ngFor="let data of candidateInfo.qualifications; let i = index">
                                            <b>{{ i + 1 }}</b>: {{ data?.courseOrQualification }}
                                            <span *ngIf="data?.finishedYear">({{ data?.finishedYear }})</span>
                            
                                            <!-- <b><p *ngIf="data.educationCertificate?.imageName">Certificate</p></b> -->
                            
                                            <!-- If certificate has a valid URL -->
                                            <div *ngIf="data.educationCertificate?.imageName" class="d-flex align-items-center">
                                                <a class="certificate" [href]="data.educationCertificate.imageUrl"
                                                   target="_blank"
                                                   rel="noopener noreferrer"
                                                   [attr.download]="!data.educationCertificate.imageMimeType.startsWith('image/') ? data.educationCertificate.imageName : null">
                                                <p class="fw-bold">{{ data.educationCertificate.imageName }}</p>  
                                                </a>
                                              </div>
                                        </li>
                                    </ng-container>
                            
                                    <!-- No Education Available -->
                                    <ng-template #noEducation>
                                        <li>No Education</li>
                                    </ng-template>
                                </ul>
                            </div>



                            <div class="single-profile-heading">
                                <span></span>
                                <h3>Years Of Experiences</h3>
                            </div>
                            <div class="single-profile-paragraph">
                                <ng-container *ngIf="candidateInfo?.yearsOfExperience?.length > 0 ; else noExperience">
                                    <ul>
                                    <li *ngFor="let experience of candidateInfo?.yearsOfExperience">
                                        
                                        <div class="d-flex justify-content-between w-100">
                                            <div>
                                        <h6>{{experience.jobTitle}}</h6>
                                        <!-- <p>{{experience.companyName}}</p> -->
                                    </div>
                                    <div>
                                    <ng-container *ngIf="experience?.endedMonth && experience?.endedYear; else presentTemplate" >
                                        <h6>({{experience?.startedYear}}) -  ({{experience?.endedYear}})</h6>
                                      </ng-container>
                                    
                                      <ng-template #presentTemplate>
                                        <div>
                                            <h6>({{experience?.startedYear}}) - present </h6>
                                        </div>
                                      </ng-template>                                
                                    </div>
                                    </div>
                                      </li>
                                    </ul>
                                </ng-container>
                                <ng-template #noExperience>
                                 <p>No Experience</p>
                                </ng-template>
                            </div>
                        </div>
          
                            <div class="single-profile-item" >
                                <div class="single-profile-right">
                            <div class="single-profile-textarea"> 
                                <div class="single-profile-heading">
                                    <span></span>
                                    <h3>Identification Documents</h3>
                                </div>
            
                                <div class="row">
                                    <div class="col-lg-6">
                                    <h6><b>Passport</b></h6>
                                    <div *ngIf="candidateInfo.candidatePassportDetails?.length; else noPassport">
                                        <!-- Loop through all passport details -->
                                        <div *ngFor="let passport of candidateInfo.candidatePassportDetails">
                                            <div *ngIf="passport.imageUrl">
                                                <!-- Display only the image name -->
                                                <div class="d-flex">
                                                    <a class="certificate" [href]="passport.imageUrl" target="_blank" rel="noopener noreferrer">
                                                        <span>{{ passport.imageName }}</span>
                                                      </a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    
                                    <!-- No passport available message -->
                                    <ng-template #noPassport>
                                        <p>No Passport Available</p>
                                    </ng-template>
                                    
                         
                                    </div>
            
                                    <div class="col-lg-6">
                                        <h6><b>Driving License</b></h6>
                                        <div *ngIf="candidateInfo.candidateDrivingLicenseDetails?.length; else noDriving">
                                            <!-- Loop through all passport details -->
                                            <div *ngFor="let data of candidateInfo.candidateDrivingLicenseDetails">
                                                <div *ngIf="data.imageUrl">
                                                    <!-- Display only the image name -->
                                                    <div class="d-flex">
                                                        <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                            <span>{{ data.imageName }}</span>
                                                          </a>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- No passport available message -->
                                        <ng-template #noDriving>
                                            <p>No Driving License Available</p>
                                        </ng-template>
                                        
                                        </div>
            
                                   <div class="col-lg-6 mt-3">
                                    <h6><b>MediCare</b></h6>
                                    <div *ngIf="candidateInfo.candidateMediCareDetails?.length; else noMedicare">
                                                <!-- Loop through all passport details -->
                                    <div *ngFor="let data of candidateInfo.candidateMediCareDetails">
                                    <div *ngIf="data.imageUrl; else noMediImage">
                                                        <!-- Display only the image name -->
                                                        <div class="d-flex">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                                <span>{{ data.imageName }}</span>
                                                              </a>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- No passport available message -->
                                            <ng-template #noMedicare>
                                                <p>No MediCare Available</p>
                                            </ng-template>
                                            
                                            <!-- No image available message -->
                                            <ng-template #noMediImage>
                                                <p>No Image Available</p>
                                            </ng-template>
                                   </div> 
                                   
                                   <div class="col-lg-6 mt-3">
                                    <h6><b>MediBank</b></h6>
                                    <div *ngIf="candidateInfo.candidateMediBankDetails?.length; else noMedicare">
                                        <!-- Loop through all passport details -->
                                        <div *ngFor="let data of candidateInfo.candidateMediBankDetails">
                                            <div *ngIf="data.imageUrl; else noMediBankImage">
                                                <!-- Display only the image name -->
                                                <div class="d-flex">
                                                    <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                        <span>{{ data.imageName }}</span>
                                                      </a>
                                                
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <!-- No passport available message -->
                                    <ng-template #noMedicare>
                                        <p>No MediCare Available</p>
                                    </ng-template>
                                    
                                    <!-- No image available message -->
                                    <ng-template #noMediBankImage>
                                        <p>No Image Available</p>
                                    </ng-template>
                                    </div>
                                </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item">
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                       <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Industry Currency</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                <ng-container *ngIf="candidateInfo?.industryCurrency?.length; else noIndustryCurrency">
                                                    <li *ngFor="let data of candidateInfo?.industryCurrency; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.industryCurrencyType }}
                                                        <span *ngIf="data.industryCurrencyExpiry"> ({{ data.industryCurrencyExpiry }}) </span>
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                                    </li>
                                                </ng-container>
                                        
                                                <!-- No Industry Currency Available -->
                                                <ng-template #noIndustryCurrency>
                                                    <li>No Industry Currency Available</li>
                                                </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item" >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Industry Currency Verification</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                             
                                    <!-- Industry Currency Verification Files -->
                                    <ng-container *ngIf="candidateInfo?.industryCurrencyVerification?.length; else noIndustryCurrencyVerification">
                                                    <li *ngFor="let data of candidateInfo.industryCurrencyVerification; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.industryCurrencyVerificationType }}
                                                        <span *ngIf="data.industryCurrencyVerificationExpiry"> ({{ data.industryCurrencyVerificationExpiry }}) </span>
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                                    </li>
                                    </ng-container>
                                     <!-- No Industry Currency Available -->
                                     <ng-template #noIndustryCurrencyVerification>
                                        <li>No Industry Currency Verification Available</li>
                                    </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
            
                            <!-- <div class="single-profile-item" >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Reference Check</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                             
                                        Reference check Verification Files
                                         <ng-container *ngIf="candidateInfo?.refrenceCheck?.length; else noReferenceCheckVar">
                                                    <li *ngFor="let data of candidateInfo?.refrenceCheck; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.refrenceCheckType}}
                                                        <span *ngIf="data.industryCurrencyVerificationExpiry"> ({{ data.industryCurrencyVerificationExpiry }}) </span>                          
                                                        <b><p *ngIf="data.imageName">Certificate</p></b>
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                                <p class='fw-bold'> <b>{{ i + 1 }}</b>:<span class="ms-2">{{ data.imageName }}</span></p>
                                                            </a>
                                                          </div>
                                                    </li>
                                    </ng-container>
                                     No Reference checks Available
                                     <ng-template #noReferenceCheckVar>
                                        <li>No Reference Check Available</li>
                                    </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div> -->


                            <div class="single-profile-item" >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Reference Check Verification</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                             
                                        <!-- Reference check Verification Files -->
                                         <ng-container *ngIf="candidateInfo?.refrenceCheckVerification?.length; else noReferenceCheckVerification">
                                                    <li *ngFor="let data of candidateInfo?.refrenceCheckVerification; let i = index">
                                                        <!-- <b>{{ i + 1 }}</b>: {{ data.refrenceCheckType}} -->
                                                        <!-- <span *ngIf="data.industryCurrencyVerificationExpiry"> ({{ data.industryCurrencyVerificationExpiry }}) </span>                           -->
                                                        <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                                <p class='fw-bold'> <b>{{ i + 1 }}</b>:<span class="ms-2">{{ data.imageName }}</span></p>
                                                            </a>
                                                          </div>
                                                    </li>
                                    </ng-container>
                                     <!-- No Reference checks Available -->
                                     <ng-template #noReferenceCheckVerification>
                                        <li>No Reference Check Verification Available</li>
                                    </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item" >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>PD Log And Plan</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                             
                                    <!-- Industry Currency Verification Files -->
                                         <ng-container *ngIf="candidateInfo?.pdLogAndPlan?.length; else noPdLogAndPlan">
                                                    <li *ngFor="let data of candidateInfo?.pdLogAndPlan; let i = index">      
                                                        <b>{{ i + 1 }}</b>: {{ data.pdLogAndPlanType }}
                                                        <span *ngIf="data.pdLogAndPlanExpiry"> ({{ data.pdLogAndPlanExpiry }}) </span>                      
                                                        <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                                    </li>
                                        </ng-container>
                                        <!-- No Industry Currency Available -->
                                         <ng-template #noPdLogAndPlan>
                                            <li>No PD Log And Plan Available</li>
                                         </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item">
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>USI Report</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                <!-- USI Report List -->
                                                <ng-container *ngIf="candidateInfo?.usiReport?.length; else noUsiReport">
                                                    <li *ngFor="let data of candidateInfo.usiReport; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.usiReportType }}
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                        
                                                        <!-- Expiry Date -->
                                                        <div *ngIf="data.usiReportExpiry">
                                                            <b>Expiry Date:</b> {{ data.usiReportExpiry }}
                                                        </div>
                                                    </li>
                                                </ng-container>
                                        
                                                <!-- No USI Report Available -->
                                                <ng-template #noUsiReport>
                                                    <li>No USI Report Available</li>
                                                </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item " >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                      
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Trainer Matrix</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                <!-- Matrix File -->
                                                <ng-container *ngIf="candidateInfo?.matrix?.length; else noMatrixFile">
                                                    <li *ngFor="let data of candidateInfo.matrix; let i = index">
                                                        <!-- <b>{{ i + 1 }}</b>: {{ data.fieldName }} -->
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Certificate</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                                 <p class='fw-bold'><b>{{ i + 1 }}</b>: <span class="ms-2">{{ data.imageName }}</span></p>
                                                            </a>
                                                          </div>
                                                    </li>
                                                </ng-container>
                                        
                                                <!-- No Matrix File Available -->
                                                <ng-template #noMatrixFile>
                                                    <li>No Matrix File Available</li>
                                                </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item " >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                      
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Resume</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                <!-- Resume List -->
                                                <ng-container *ngIf="candidateInfo?.resumeDocs?.length; else noResume">
                                                    <li *ngFor="let data of candidateInfo.resumeDocs; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.resumeType }}
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                        
                                                        <!-- Expiry Date -->
                                                        <div *ngIf="data.resumeExpiry">
                                                            <b>Expiry Date:</b> {{ data.resumeExpiry }}
                                                        </div>
                                                    </li>
                                                </ng-container>
                                        
                                                <!-- No Resume Available -->
                                                <ng-template #noResume>
                                                    <li>No Resume Available</li>
                                                </ng-template>
                                            </ul>
                                        </div>
                                        
            
                                    </div>
                                </div>
                            </div>
            
                            <div class="single-profile-item " >
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                      
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Additional Certificates</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                <!-- Additional Certificate List -->
                                                <ng-container *ngIf="candidateInfo?.candidateAdditionalCertificateDetails?.length; else noCertificate">
                                                    <li *ngFor="let data of candidateInfo.candidateAdditionalCertificateDetails; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.additionalCertificateType }}
                                        
                                                        <!-- <b><p *ngIf="data.imageName">Document</p></b> -->
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                        
                                                        <!-- Expiry Date -->
                                                        <div *ngIf="data.additionalCertificateExpiry">
                                                            <b>Expiry Date:</b> {{ data.additionalCertificateExpiry }}
                                                        </div>
                                                    </li>
                                                </ng-container>
                                        
                                                <!-- No Certificates Available -->
                                                <ng-template #noCertificate>
                                                    <li>No Additional Certificates Available</li>
                                                </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
            
                            <!-- <div class="single-profile-item ">
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                      
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Medical Certificate</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                                Medical Certificate List
                                                <ng-container *ngIf="candidateInfo?.medicalCertificate?.length; else noMedicalCertificate">
                                                    <li *ngFor="let data of candidateInfo.medicalCertificate; let i = index">
                                                        <b>{{ i + 1 }}</b>: {{ data.medicalCertificateType }}
                                        
                                                        <b><p *ngIf="data.imageName">Document</p></b>
                                        
                                                        <div *ngIf="data.imageName" class="d-flex align-items-center">
                                                            <a class="certificate" [href]="data.imageUrl" target="_blank" rel="noopener noreferrer">
                                                              <p class='fw-bold'>{{ data.imageName }}</p>
                                                            </a>
                                                          </div>
                                        
                                                        Expiry Date
                                                        <div *ngIf="data.medicalCertificateExpiry">
                                                            <b>Expiry Date:</b> {{ data.medicalCertificateExpiry }}
                                                        </div>
                                                    </li>
                                                </ng-container>
                                        
                                                No Medical Certificate Available
                                                <ng-template #noMedicalCertificate>
                                                    <li>No Medical Certificate Available</li>
                                                </ng-template>
                                            </ul>
                                        </div> 
                                    </div>
                                </div>
                            </div> -->
            
                            <div class="single-profile-item">
                                <div class="single-profile-right">
                                    <div class="single-profile-textarea">
                                     
                                        <div class="single-profile-heading">
                                            <span></span>
                                            <h3>Professional Development</h3>
                                        </div>
                                        
                                        <div class="single-profile-paragraph">
                                            <ul class="unordered-list">
                                             
                                    <!-- pd Files -->
                                    <ng-container *ngIf="candidateInfo?.pds?.length; else noPd">
                                        <li *ngFor="let data of candidateInfo?.pds; let i = index">      
                                            <b>{{ i + 1 }}</b>: {{ data.pdsType }}
                                            <span *ngIf="data.pdsExpiry && data.pdsExpiry !== 'null'"> ({{ data.pdsExpiry }}) </span>                      
                                            
                                            <!-- <b><p *ngIf="data.filesDetails.imageName">Certificate</p></b> -->
                                    
                                            <div *ngIf="data.filesDetails.imageName" class="d-flex align-items-center">
                                                <a class="certificate" [href]="data.filesDetails.imageUrl" target="_blank" rel="noopener noreferrer">
                                                  <p class='fw-bold'>{{ data.filesDetails.imageName }}</p>
                                                </a>
                                              </div>
                                        </li>
                                    </ng-container>
                                        <!-- No Industry Currency Available -->
                                         <ng-template #noPd>
                                            <li>No PD Available</li>
                                         </ng-template>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            </div>
        </div>
 
